import {
  Box,
  BoxProps,
  Flex,
  HStack,
  Image,
  Text,
  Tooltip,
  useBreakpointValue,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Link,
} from "@chakra-ui/react";

import {
  Sidebar as SidebarComponent,
  Menu,
  MenuItem,
  menuClasses,
} from "react-pro-sidebar";
import { BiLogOut } from "react-icons/bi";

import { useState } from "react";
import {
  BsFillArrowLeftCircleFill,
  BsFillArrowRightCircleFill,
  BsFillXCircleFill,
} from "react-icons/bs";
import { AiFillLock } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import { HeaderOption as Option } from "../../../models/Home";
import { useMediaQuery } from "react-responsive";
import HeaderOption from "../../Header/HeaderOption";
import HeaderMenuContent from "../../Header/HeaderMenuContent";

interface SidebarProps extends BoxProps {
  sideBarRoutes: Option[];
  onClose: () => void;
}

export const Sidebar = ({ sideBarRoutes, onClose, ...rest }: SidebarProps) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [collapsed, setCollapsed] = useState(!isMobile);

  const location = useLocation();

  function findActiveIndex(href: string) {
    return location.pathname.includes(href);
  }

  return (
    <SidebarComponent
      backgroundColor="white"
      style={{
        height: "full",
        width: isMobile ? "100%" : "",
        justifyContent: "space-between",
        alignContent: "center",
        alignSelf: "center",
      }}
      collapsed={collapsed}
    >
      {!collapsed ? (
        <Flex
          p="20px"
          transition="ease-in-out"
          transitionDuration={"100"}
          justify={"space-between"}
          alignContent="center"
          alignItems="center"
        >
          <Link href="/">
            <Image
              w="150px"
              src={
                process.env.REACT_APP_LOGO === "syntra"
                  ? `${process.env.PUBLIC_URL}/syntraLogo.png`
                  : `${process.env.PUBLIC_URL}/grupoCvfLogo.png`
              }
              alt="logo"
            />
          </Link>

          {isMobile ? (
            <BsFillXCircleFill
              color="var(--icon-color)"
              size="20px"
              onClick={() => onClose()}
            ></BsFillXCircleFill>
          ) : (
            <BsFillArrowLeftCircleFill
              color="var(--icon-color)"
              size="20px"
              onClick={() => setCollapsed(true)}
            ></BsFillArrowLeftCircleFill>
          )}
        </Flex>
      ) : (
        <Flex
          p="20px"
          justify={"space-between"}
          alignItems="center"
          flexDir="column"
        >
          <Link href="/">
            <Image
              maxW="100px"
              h="50px"
              mb="4px"
              src={
                process.env.REACT_APP_LOGO === "syntra"
                  ? `${process.env.PUBLIC_URL}/syntraLogoM.png`
                  : `${process.env.PUBLIC_URL}/logo.png`
              }
              alt="logo"
            />
          </Link>
          <BsFillArrowRightCircleFill
            color="var(--icon-color)"
            size="20px"
            onClick={() => setCollapsed(false)}
          ></BsFillArrowRightCircleFill>
        </Flex>
      )}

      <Menu
        rootStyles={{
          ["." + menuClasses.button]: {
            "&:hover": {
              backgroundColor: "var(--icon-color)",
              color: "white",
            },
          },
        }}
      >
        {sideBarRoutes.map((route, index) => (
          <Box
            id={route.title}
            key={route.link + index}
            color={findActiveIndex(route.link) ? "white" : "var(--icon-color)"}
            bg={findActiveIndex(route.link) ? "var(--icon-color)" : "white"}
          >
            <HeaderOption key={route.title} o={route} />
          </Box>
        ))}
        {isMobile && <HeaderMenuContent gap="8px" />}
      </Menu>
    </SidebarComponent>
  );
};

export default Sidebar;
